import type { LlmUIMessageParts } from '@azymmetric/shared/types/llm.types';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import { FolderTree } from 'lucide-react';
import { MessageContent } from '../../../../ai-elements/message';
import { Spinner } from '../../../../shared/spinner.component';

export type GetTechnologyToolProps = {
  messageId: string;
  part: Extract<LlmUIMessageParts, { type: 'tool-getTechnology' }>;
  partIndex: number;
};

export const GetTechnologyTool: React.FC<GetTechnologyToolProps> = (props) => {
  const { messageId, part, partIndex } = props;

  if (part.state === 'output-available' && 'output' in part) {
    const technologyData = part.output;
    return (
      <MessageContent key={`${messageId}-${partIndex}`}>
        <div className="rounded-lg border bg-card p-3">
          <Accordion
            collapsible
            type="single"
          >
            <AccordionItem
              className="border-0"
              value="technology"
            >
              <AccordionTrigger className="py-0 text-sm hover:no-underline">
                <div className="flex items-center gap-2">
                  <div className="rounded-md bg-[#3D2EFF1A] p-1.5 text-[#3D2EFF]">
                    <FolderTree className="size-3.5" />
                  </div>
                  <span>Found technology: {technologyData.name}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent>
                <div className="rounded-md mt-2 border bg-background p-3">
                  <div className="text-sm font-medium">{technologyData.name}</div>
                  <div className="text-xs text-muted-foreground">
                    {technologyData.category.name} • {technologyData.company.name}
                  </div>
                  {technologyData.description && (
                    <p className="mt-2 text-xs text-muted-foreground">{technologyData.description}</p>
                  )}
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </MessageContent>
    );
  }

  if (part.state === 'output-error' && 'errorText' in part) {
    return (
      <MessageContent key={`${messageId}-${partIndex}`}>
        <div className="rounded-lg border border-destructive bg-destructive/10 p-4">
          <div className="text-sm text-destructive">Error retrieving technology: {part.errorText}</div>
        </div>
      </MessageContent>
    );
  }

  if (part.state === 'input-streaming' || part.state === 'input-available') {
    return (
      <MessageContent key={`${messageId}-${partIndex}`}>
        <div className="rounded-lg border bg-card p-4">
          <div className="flex items-center gap-2">
            <FolderTree className="size-4 text-muted-foreground" />
            <Spinner size="sm" />
            <span className="text-sm text-muted-foreground">Retrieving technology information...</span>
          </div>
        </div>
      </MessageContent>
    );
  }

  return null;
};
